import React from 'react';
import styled from 'styled-components';
import { Dropdown, DropdownIcon, DropdownSelect } from './AdminFilterPrimitives';

type OptionValue = string | number;

export interface AdminFilterDropdownOption {
  label: string;
  value: OptionValue;
}

interface AdminFilterDropdownProps {
  value: OptionValue;
  options: AdminFilterDropdownOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
  minWidth?: string;
  maxWidth?: string;
}

const AdminFilterDropdown: React.FC<AdminFilterDropdownProps> = ({
  value,
  options,
  onChange,
  disabled = false,
  minWidth,
  maxWidth,
}) => (
  <Dropdown>
    <SizedSelect
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      $minWidth={minWidth}
      $maxWidth={maxWidth}
    >
      {options.map((option) => (
        <option key={String(option.value)} value={option.value}>
          {option.label}
        </option>
      ))}
    </SizedSelect>
    <DropdownIcon width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M4.17 5.25L7 8.08L9.83 5.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </DropdownIcon>
  </Dropdown>
);

const SizedSelect = styled(DropdownSelect)<{ $minWidth?: string; $maxWidth?: string }>`
  ${({ $minWidth }) => $minWidth && `min-width: ${$minWidth};`}
  ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth};`}
`;

export default AdminFilterDropdown;
